import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'

import { sendHoverSoundCommand } from 'react-wot-bootstrap'

import { changeSort } from 'state/actions/available_units'

import DefaultTooltip from 'components/DefaultTooltip/DefaultTooltip'

import { BATTLE_ROOMS_COLUMNS } from 'containers/BattleRooms/constants'
import { TOOLTIPS } from './tooltips'

import styles from '../../UnitsList.scss'

export class TableHeader extends React.Component {
    static propTypes = {
        sort: PropTypes.shape({
            prop: PropTypes.oneOf(['places', 'server']),
            order: PropTypes.oneOf(['asc', 'desc']),
        }).isRequired,
        changeSort: PropTypes.func.isRequired,
    }

    render() {
        const getSortableHeaderClassNames = name => classNames(
            styles.th,
            styles.th__sortable,
            styles.th__center,
            {
                [styles.th__asc] : this.props.sort.prop === name && this.props.sort.order === 'asc',
                [styles.th__desc] : this.props.sort.prop === name && this.props.sort.order === 'desc',
            },
        )
        const basisTHClassName = classNames(styles.th, styles.th__basis)
        const centeredTHClassName = classNames(styles.th, styles.th__center)
        const theadTRCLassName = classNames(styles.tr, styles.tr__thead)

        const thConditionsNodes = [
            <div key={0} className={classNames(styles.thCondition, styles.thCondition__active)} />,
            <div key={1} className={classNames(styles.thCondition, styles.thCondition__hover)} />,
        ]

        return (
            <div className={styles.thead}>
                <div className={theadTRCLassName}>
                    <div
                        className={basisTHClassName}
                        onMouseEnter={sendHoverSoundCommand}
                        onClick={() => this.props.changeSort(null)}
                        data-tip data-for={TOOLTIPS.clan.id}
                    >
                        <div className={styles.thTitle}>
                            {BATTLE_ROOMS_COLUMNS.clan}
                        </div>
                        <DefaultTooltip {...TOOLTIPS.clan} />
                        {thConditionsNodes}
                    </div>

                    <div
                        className={centeredTHClassName}
                        data-tip data-for={TOOLTIPS.rating.id}
                    >
                        <div className={styles.thTitle}>
                            <div className={styles.ratingIcon}/>
                        </div>
                        <DefaultTooltip {...TOOLTIPS.rating} />
                    </div>

                    <div
                        className={getSortableHeaderClassNames('server')}
                        onMouseEnter={sendHoverSoundCommand}
                        onClick={() => this.props.changeSort('server')}
                        data-tip data-for={TOOLTIPS.server.id}
                    >
                        <div className={styles.thTitle}>
                            {BATTLE_ROOMS_COLUMNS.server}
                        </div>
                        <DefaultTooltip {...TOOLTIPS.server} />
                        {thConditionsNodes}
                    </div>

                    <div
                        className={centeredTHClassName}
                        data-tip data-for={TOOLTIPS.squad.id}
                    >
                        <div className={styles.thTitle}>
                            {BATTLE_ROOMS_COLUMNS.squad}
                        </div>
                        <DefaultTooltip {...TOOLTIPS.squad} />
                    </div>

                    <div
                        className={getSortableHeaderClassNames('places')}
                        onMouseEnter={sendHoverSoundCommand}
                        onClick={() => this.props.changeSort('places')}
                        data-tip data-for={TOOLTIPS.places.id}
                    >
                        <div className={styles.thTitle}>
                            {BATTLE_ROOMS_COLUMNS.places}
                        </div>
                        <DefaultTooltip {...TOOLTIPS.places} />
                        {thConditionsNodes}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        sort: state.availableUnits.sort,
    }
}

const mapDispatchToProps = {
    changeSort,
}


export default connect(mapStateToProps, mapDispatchToProps)(TableHeader)


// WEBPACK FOOTER //
// ./containers/BattleRooms/components/UnitsList/components/TableHeader/TableHeader.jsx